exports.FreeTier = {Limit: 3, Price: 0};
exports.PaidTier = {Limit: Infinity, Price: 8};
